"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiException = void 0;
const domain_exception_1 = require("./domain.exception");
/**
 * Should be thrown when attempting to contact an API but the request did not succeed.
 *
 * For example:
 * - Receiving an unexpected status code
 * - Request timeout
 */
class ApiException extends domain_exception_1.DomainException {
    constructor(message, data) {
        super(message, data);
    }
}
exports.ApiException = ApiException;
